module.exports = __webpack_public_path__ + "img/BPPMP5.24ae2256.png";